import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/addDropDownReviewSection/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showAddDropDownReviewSectionSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showAddDropDownReviewSectionSelector };
